const getStoreLocatorState = (state) => state.storeLocator

export const selectStoreLocator = (state) => getStoreLocatorState(state)



// WEBPACK FOOTER //
// ./src/store/storeLocator/selectors.js